var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0756 9.68732C4.07561 9.68732 4.07561 9.68732 4.07561 9.68733L5.15056 17.2255C5.37303 18.7855 6.70673 19.9443 8.27981 19.9443H15.7204C17.2936 19.9443 18.6272 18.7855 18.8497 17.2255L18.8497 17.2254L19.9247 9.68737C19.9247 9.68735 19.9247 9.68733 19.9247 9.68731C20.106 8.4154 19.1209 7.27761 17.8385 7.27761H6.16177C4.87936 7.27761 3.89425 8.41546 4.0756 9.68732ZM1.98944 9.98587C1.62673 7.44224 3.59691 5.1665 6.16177 5.1665H17.8385C20.4035 5.1665 22.3735 7.44226 22.0109 9.98582L22.0109 9.98589L20.9358 17.524C20.5651 20.1241 18.3423 22.0554 15.7204 22.0554H8.27981C5.65801 22.0554 3.43518 20.1241 3.0644 17.524L4.10596 17.375L3.0644 17.524L1.98944 9.98588L1.98944 9.98587Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7318 3.8615C7.62426 2.07338 9.4484 0.944336 11.4438 0.944336H12.5562C14.5518 0.944336 16.3759 2.07382 17.2684 3.86183L17.2684 3.86185L18.2108 5.75006C18.471 6.27148 18.2601 6.90553 17.7396 7.16623C17.2191 7.42694 16.5862 7.21559 16.3259 6.69416L15.3835 4.80598C14.848 3.73311 13.7535 3.05545 12.5562 3.05545H11.4438C10.2464 3.05545 9.15208 3.73288 8.61667 4.80561L7.67407 6.69417C7.41383 7.21559 6.78091 7.42694 6.26042 7.16623C5.73993 6.90552 5.52896 6.27147 5.7892 5.75005L6.7318 3.8615Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.ea2a5900bff04a73e1147bf20b180782.svg";
export { ForwardRef as ReactComponent };